/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Bar_Ez_LbInputs */

const en_us2_workout_logging_bar_ez_lb = /** @type {(inputs: Workout_Logging_Bar_Ez_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EZ ~25 lb`)
};

const pt_br2_workout_logging_bar_ez_lb = /** @type {(inputs: Workout_Logging_Bar_Ez_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EZ ~25 lb`)
};

const es_419_workout_logging_bar_ez_lb = /** @type {(inputs: Workout_Logging_Bar_Ez_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EZ ~25 lb`)
};

const pt_pt2_workout_logging_bar_ez_lb = /** @type {(inputs: Workout_Logging_Bar_Ez_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EZ ~25 lb`)
};

const fr_fr2_workout_logging_bar_ez_lb = /** @type {(inputs: Workout_Logging_Bar_Ez_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EZ ~25 lb`)
};

const de_de2_workout_logging_bar_ez_lb = /** @type {(inputs: Workout_Logging_Bar_Ez_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SZ ~25 lb`)
};

const it_it2_workout_logging_bar_ez_lb = /** @type {(inputs: Workout_Logging_Bar_Ez_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EZ ~25 lb`)
};

/**
* | output |
* | --- |
* | "EZ ~25 lb" |
*
* @param {Workout_Logging_Bar_Ez_LbInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_bar_ez_lb = /** @type {((inputs?: Workout_Logging_Bar_Ez_LbInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Bar_Ez_LbInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_bar_ez_lb(inputs)
	if (locale === "es-419") return es_419_workout_logging_bar_ez_lb(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_bar_ez_lb(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_bar_ez_lb(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_bar_ez_lb(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_bar_ez_lb(inputs)
	return en_us2_workout_logging_bar_ez_lb(inputs)
});
export { workout_logging_bar_ez_lb as "workout-logging.bar_ez_lb" }